import {
  getCourseCodeErrorsUrl,
  getDownloadErrorFileUrl,
} from "../config/Config";
import { getRequest } from "./ServiceHelper";

export class CourseCodeErrorService {
  static getCourseCodeErrors = () => {
    return getRequest(getCourseCodeErrorsUrl());
  };

  static downloadCourseCodeErrorFileUrl = (filePath, fileName, fileKey) => {
    return getRequest(getDownloadErrorFileUrl(filePath, fileName, fileKey));
  };
}
